import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NavbarIconsCatalogInstitutions from "../generic-nav-bar/NavbarIconsCatalogInstitutions";
import { useTranslation } from "react-i18next";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { schemaValidateCatalogInstitutionsList } from "../../app/data/schemaValidateCatalogInstitutionsList";
import useFormValidationsGeneric from "../../app/hooks/useFormValidationsGeneric";
import ViewLabel from "../generic-component/ViewLabel";
import NewInputGeneric from "../generic-component/NewInputGeneric";
import NewRelationGeneric from "../generic-component/NewRelationGeneric";
import NewTextGeneric from "../generic-component/NewTextGeneric";
import EditYearGeneric from "../generic-component/EditYearGeneric";
import NewDateGeneric from "../generic-component/NewDateGeneric";
import NewCatalogRelationGeneric from "../generic-component/NewCatalogRelationGeneric";
import NewCatalogLocationGeneric from "../generic-component/NewCatalogLocationGeneric";
import { catalogInstitutionClean, catalogInstitutionStartUpdate } from "../../app/actions/catalogInstitutionActions";

const ID_FORM = "admin-institution";
const OPERATION = "edit";

const EditCatalogInstitutions = () => {
  debugLogPages(':: EditCatalogInstitutions');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { catalogInstitution, listFullCatalogInstitutions } = useSelector((state) => state.catalogInstitution);

    const { values, errors, handleChange, handleSubmit,
    handleChangeCatalogSection, handleChangeCatalogPhase, handleChangeCatalogInstitution, handleChangeLocation } = useFormValidationsGeneric(
      () => catalogInstitutionCallback(),
      catalogInstitution,
      schemaValidateCatalogInstitutionsList
    );

    useEffect(() => {
        
        if (values) {
          handleChange(getObjectById(values.parent_id, listFullCatalogInstitutions), "parent_id");
    
        }
    
      }, [listFullCatalogInstitutions])

      const getObjectById = (id, arraySearch) => {
        const elementFound = arraySearch.find((ser) => ser.id === id);
        return elementFound;
      };
    
         const getMethodData = (currentData) => {
          //console.log("getMethodData, currentData", currentData);
        let comboData = [];
        let level = 0;
    
        if (currentData === "parent_id") {
          comboData = listFullCatalogInstitutions;
          level = 1;
        } 
    
        return { comboData, level };
      };

  function catalogInstitutionCallback() {
    debugLogPages(':: EditCatalogInstitutions, catalogInstitutionCallback, values', {values}); 

    let valuesSubmit = { ...values };
    valuesSubmit.deleted = false;

    debugLogPages(':: EditCatalogInstitutions, catalogInstitutionCallback, valuesSubmit', {valuesSubmit}); 
    dispatch(catalogInstitutionStartUpdate(valuesSubmit, navigate));

    dispatch(catalogInstitutionClean());
  }


  debugLogPages(':: EditCatalogInstitutions', {values}); 
  debugLogPages(':: EditCatalogInstitutions', {errors})

  return (
    <div>
      <NavbarIconsCatalogInstitutions page={"editCatalogInstitutions"} />
      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="section is-fullheight">
        <div className="container">
          <form onSubmit={handleSubmit} noValidate>

          {/* Formulario dinamico*/}

            <div className="row boxContent">
              {
                schemaValidateCatalogInstitutionsList && schemaValidateCatalogInstitutionsList.length > 0 && (
                  schemaValidateCatalogInstitutionsList.map((techSecondary, index) => {

                    let varField = techSecondary.field;
                    let varRelation = techSecondary.key_relation;
                    const { comboData, level } = getMethodData(techSecondary.field);

                    if (techSecondary.component_new === "ViewGroupLabel") {
                      return (
                        <ViewLabel
                          key={techSecondary.id}
                          values={values}
                          errors={errors}
                          values2={varRelation}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_view}
                        />
                      )
                    } if (techSecondary.component_new === "NewInputGeneric") {
                      return (
                        <NewInputGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewRelationGeneric") {
                      return (
                        <NewRelationGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                          comboData={comboData}
                        />
                      );
                    } else if (techSecondary.component_new === "NewTextGeneric") {
                      return (
                        <NewTextGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewYearGeneric") {

                      return (
                        <EditYearGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewDateGeneric") {
                      return (
                        <NewDateGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    }  else if (techSecondary.component_new === "NewCatalogRelationGeneric") {
                      return (
                        <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogInstitution}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}
                            comboData={comboData}
                            level={level}
                        />
                      );
                    } else if (techSecondary.component_new === "NewCatalogRelationGeneric1") {
                      if (techSecondary.comparable_relation_condition === "CatalogInstitutions") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogInstitution}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogSections") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogSection}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogPhases") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogPhase}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      }
                    } else if (techSecondary.component_new === "NewCatalogLocationGeneric") {
                      return (
                        <NewCatalogLocationGeneric
                          key={techSecondary.id}
                          handleChange={handleChangeLocation}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        
                        />
                      );
                    } else {
                      return (
                        <div>
                        </div>
                      )
                    }
                  })
                )
              }
            </div>

            {/* Fin Formulario dinamico */}

            <div className="btnGuardar">
              <input type="submit" value={t("buttons.submit")} className="btn btn-primary" />
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default EditCatalogInstitutions;
